import '../../styles/pages.css';
import '../../styles/layout.css';

const FarmersLogo = `${process.env.PUBLIC_URL}/Farmers_Insurance_Group_logo.svg`;

export default function LoginPage() {
  const params = new URLSearchParams(window.location.search);
  const showNowcerts = params.get('support') === 'true';

  const handleFarmersClick = () => {
    window.location.href = process.env.REACT_APP_Farmers_Url as string;
  };

  const handleNowcertsClick = () => {
    const baseUrl = process.env.REACT_APP_Nowcerts_Url as string;
    const innerPath = 'Pages/InsuranceGIG/RedirectToIG.aspx';
    const innerParams = new URLSearchParams({
      igorigin: 'coi',
      agencyId: '2aa29171-0d21-4641-a774-7fac291a1cc2',
      showAgencyLogo: 'true',
    });
    const internalReturnUrl = `${innerPath}?${innerParams.toString()}`;
    const finalUrl = `${baseUrl}?InternalReturnUrl=${encodeURIComponent(internalReturnUrl)}`;
    if (window.innerWidth > 767) {
      window.location.href = finalUrl;
    } else {
      window.open(finalUrl, '_blank');
    }
  };

  return (
    <div className="loginShell">
      <div className="loginShell__panel">
        <div className="loginShell__brand">
          <img src={FarmersLogo} alt="Farmers" className="loginShell__brandLogo" />
        </div>

        <div className="loginShell__headline">Sign in to continue</div>
        <p className="loginShell__subtext">
          Access certificates, requests, policies and reports in a single workspace.
        </p>

        <div className="loginShell__actions">
          <button
            type="button"
            className="loginShell__primaryBtn"
            onClick={handleFarmersClick}
          >
            <i className="pi pi-verified" style={{ marginRight: 8, fontSize: 15 }} />
            Continue with Farmers
          </button>

          {showNowcerts && (
            <>
              <div className="loginShell__divider"><span>or</span></div>

              <button
                type="button"
                className="loginShell__outlineBtn"
                onClick={handleNowcertsClick}
              >
                <i className="pi pi-sign-in" style={{ marginRight: 8, fontSize: 14 }} />
                Continue with Nowcerts
              </button>
            </>
          )}
        </div>

        <p className="loginShell__hint">Secure single sign-on powered by your existing account.</p>
      </div>
    </div>
  );
}
